import { TYPES } from 'action-types/sap';
import { pdfResponse } from './models'
import * as msgs from '../../constants/validationMessages';


export interface ISapAction {
    readonly type: string;
    readonly errors?: string | string[];
    readonly pdf: pdfResponse,
    readonly resendResponse: string
}

export interface ISapState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string;
    readonly pdf: pdfResponse
    readonly resendResponse: string
    readonly isResendFetchDataLoading: boolean;
    readonly isResendFetchDataError: boolean;
    readonly resendPendingError: string | string[];
}

export const defaultState: ISapState = {
    isFetchDataError: false,
    pendingError: '',
    isFetchDataLoading: false,
    pdf: {
        MT_ViewPDF_Response: {
            URL: null,
            Error_Desc: null,
        }
    },
    resendResponse: '',
    isResendFetchDataLoading: false,
    isResendFetchDataError: false,
    resendPendingError: ''
};
const check = (err: any) => {
    if (err && !Array.isArray(err) ||
        (err && Array.isArray(err) && err.length > 0)) {
        return err
    }
    return ''
}
export const reducer = (state: ISapState = defaultState, action: ISapAction): ISapState => {
    switch (action.type) {
        case TYPES.FETCH_PDF.PENDING:
        case TYPES.RESET_PDF.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: '',
                pdf: defaultState.pdf,
            };
        case TYPES.FETCH_PDF.FULFILLED:
            return {
                ...state,
                pdf: action.pdf,
                isFetchDataLoading: false,
                isFetchDataError: false,
            };
        case TYPES.FETCH_PDF.REJECTED:
            const pdfErr = JSON.parse(JSON.stringify(defaultState.pdf));
            pdfErr.MT_ViewPDF_Response.Error_Desc = msgs.Sap.Error_Msg
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pdf: pdfErr,
                pendingError: check(action.errors) ? check(action.errors) : msgs.Sap.Error_Msg
            };
        case TYPES.RESEND_MESSAGE.PENDING:
            return {
                ...state,
                isResendFetchDataLoading: true,
                isResendFetchDataError: false,
                resendPendingError: '',
                resendResponse: ''
            };
        case TYPES.RESEND_MESSAGE.FULFILLED:
            return {
                ...state,
                isResendFetchDataLoading: false,
                isResendFetchDataError: false,
                resendResponse: action.resendResponse
            };
        case TYPES.RESEND_MESSAGE.REJECTED:
            return {
                ...state,
                isResendFetchDataLoading: false,
                isResendFetchDataError: true,
                resendResponse: msgs.Sap.Resend_Response,
                resendPendingError: check(action.errors) ? check(action.errors) : msgs.Sap.Resend_Response
            };
        default:
            return state;
    }
};
